<template>
    <v-card>
        <v-card-title>お相手選択</v-card-title>
        <v-card-subtitle>{{ customer.family_name }} {{ customer.given_name }} ({{customer.family_name_kana}} {{customer.given_name_kana}})</v-card-subtitle>
        <v-container fluid>
            <v-row dense>
                <v-col>
                    <v-btn
                        :to="`/customer/${$route.params.id}`"
                    >カルテ
                    </v-btn>
                    <v-btn
                        :to="`/customer/history/${$route.params.id}`"
                    >経緯表
                    </v-btn>
                    <v-btn
                        v-if="customer.gender!=2"
                        :to="`/customer/matching/${$route.params.id}`"
                    >お相手選択
                    </v-btn>
                    <v-btn
                        v-else
                        :to="`/customer/matching_history/${$route.params.id}`"
                    >お相手履歴
                    </v-btn>
                    <v-btn
                        @click="openSheet(customer.sheet_id)"
                        v-if="customer.sheet_id"
                    >旧カルテを開く
                    </v-btn>
                    <v-btn
                        :to="`/customer/file-manager/${$route.params.id}`"
                    >画像管理
                    </v-btn>
                    <v-btn :class="{'pink white--text' : claimFiles.length}"
                           :to="`/customer/claim-manager/${$route.params.id}`"
                    >クレーム管理
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <selectMatching @setCustomer="setCustomer" isMultiple="true" :onSave="save"></selectMatching>
        <v-snackbar
            v-model="finishSave"
            timeout="2000"
        >
            保存しました。
        </v-snackbar>
    </v-card>
</template>

<script>
import selectMatching from "@/components/Matching.vue";
import utilDatetime from "@/utilities/datetime.js"
export default {
    components: {
        selectMatching,
    },
    title() {
        return `${this.customer.family_name} ${this.customer.given_name} (お相手選択)`;
    },
    name: 'customer_matching',
    mixins: [utilDatetime],
    data: () => ({
        customer: {
            family_name: "",
            given_name: "",
            family_name_kana: "",
            given_name_kana: "",
        },
        finishSave: false,
        claimFiles: [],
    }),
    created() {
        this.getClaimFiles()
    },
  methods: {
        async getClaimFiles () {
          const id = this.$route.params.id;
          const claimFiles = await this.$axios.get(`/api/v1/customer/${id}/claim-files`);
          this.claimFiles = claimFiles.data;
        },
        openSheet(sheet_id) {
            if(!sheet_id) return;
            window.open(`https://docs.google.com/spreadsheets/d/${sheet_id}`, '_blank')
        },
        setCustomer(customer) {
            this.customer = customer;
            this.setTitle();
        },
        async save(selected) {
            const id = this.$route.params.id;
            await this.$axios
                .post(`/api/v1/customer/${id}/matching_reserve`, { reserves: selected.map(s => s.id) })
                .catch((error) => {
                    console.log("Error : " + error);
                });
            this.finishSave  = true;
        },
    }
}
</script>
